import React from "react";
import { injectIntl } from "react-intl";
import {
  ErrorText,
  LoadingBox,
} from "./Styled/DeviceDataDialogComponentStyled";
import "react-circular-progressbar/dist/styles.css";
import {Loader} from "@/views/CommonComponent/Styled/CommonLoadingStyled";

function DeviceDataDialogComponent(props) {
  const { intl } = props;
  return (
    <div>
      <LoadingBox>
          <Loader style={{marginBottom:0}}>
              <svg className="spinner" viewBox="0 0 48 48">
                  <circle className="path" cx="24" cy="24" r="21.5" fill="none" strokeWidth="5"></circle>
              </svg>
          </Loader>
        {/*<CircularProgressbar*/}
        {/*  value={percentage}*/}
        {/*  text={`${percentage}%`}*/}
        {/*  strokeWidth={10}*/}
        {/*/>*/}
      </LoadingBox>
      <ErrorText><span role="img" aria-label="Warning emoji">⚠️</span>
      {intl.formatMessage({ id: "data_loading" })}
      </ErrorText> {/* 데이터를 가져오는 동안 해당창을 종료하지 마세요 */}
    </div>
  );
}
export default injectIntl(DeviceDataDialogComponent);